import * as React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ContactSubmissionForm from "./ContactSubmissionForm";
import ContactUs from "./ContactUs";
import ContactDemoRequest from "./ContactDemoRequest";
import ContactHelpCenter from "./ContactHelpCenter";
import { contactTabs } from "./ContactTabs";

// Panels are keyed by SLUG, not by array position, so commenting a tab out of
// `contactTabs` can never leave the panels misaligned with the tabs.
const panelsBySlug = {
  "submission-form": <ContactSubmissionForm />,
  "contact-us": <ContactUs />,
  "demo-request": <ContactDemoRequest />,
  "help-center": <ContactHelpCenter />,
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function ContentTabPanels({ value }) {
  // Derive the rendered panels from the tabs themselves, in tab order.
  const contentTabs = contactTabs.filter((t) => !t.isHeader);

  return (
    <>
      {contentTabs.map((tab, index) => (
        <TabPanel key={tab.slug} value={value} index={index}>
          {panelsBySlug[tab.slug] ?? null}
        </TabPanel>
      ))}
    </>
  );
}

export default ContentTabPanels;
